import Enum from "../Enum";

export default Enum.create( {
	MEDIUM: "MEDIUM",
	SMALL: "SMALL",
	TINY: "TINY",
} );
